import { Node, NodeViewRendererProps } from '@tiptap/core'
import {
  NodeViewWrapper,
  ReactNodeViewRenderer,
  useEditorState,
} from '@tiptap/react'
import { TableOfContentsStorage } from '@tiptap-pro/extension-table-of-contents'

import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { TableOfContents } from './components/TableOfContent.js'

const TableOfNodeContent = (props: NodeViewRendererProps) => {
  const { editor } = props
  const content = useEditorState({
    editor,
    selector: ctx =>
      (ctx.editor.storage.tableOfContents as TableOfContentsStorage).content,
  })

  return (
    <NodeViewWrapper>
      <div
        className="group p-2 -my-2 rounded-md relative"
        contentEditable={false}
      >
        <div
          className="h-1.5 right-0 absolute mb-2 top-3 cursor-pointer"
          onClick={() => editor.commands.deleteSelection()}
        >
          <SvgIcon
            name="trash"
            className="invisible group-hover:visible text-content-disabled hover:text-content-on-negative"
          />
        </div>
        <TableOfContents content={content} />
      </div>
    </NodeViewWrapper>
  )
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    tableOfContentsNode: {
      insertTableOfContents: () => ReturnType
    }
  }
}

export const TableOfContentsNode = Node.create({
  name: 'tableOfContentsNode',
  group: 'block',
  atom: true,
  selectable: true,
  draggable: true,
  inline: false,

  parseHTML() {
    return [
      {
        tag: 'div[data-type="table-of-content"]',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', { ...HTMLAttributes, 'data-type': 'table-of-content' }]
  },

  addNodeView() {
    return ReactNodeViewRenderer(TableOfNodeContent)
  },

  addCommands() {
    return {
      insertTableOfContents:
        () =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
          })
        },
    }
  },
})
